<template>
    <div class="living-options-properties">
      <div class="row">
        <div class="col-12">
          <div class="properties">
            <h5>Properties</h5>
            <button class="btn btn-primary mb-4" @click="addProperty()" :disabled="isAddingNewObject('properties')">Add Property</button>
            <div>
              Filter Properties
              <input class="mb-4" type="text" v-model="propertiesFilterText" placeholder="Label">
              <label><input type="checkbox" value="Available" v-model="filterStatus"> Available</label>
              <label><input type="checkbox" value="On Hold" v-model="filterStatus"> On Hold</label>
              <label><input type="checkbox" value="Sold" v-model="filterStatus"> Sold</label>
            </div>

            <v-table
              :columns="[
                { label: 'Label', field: 'label'},
                { label: 'Status', field: 'status'},
                { label: 'Price', field: 'price'},
              ]"
              :rows="filteredProperties"
              :show-active-toggle="true"
              @edit="activePropertyId = $event._id"
              @save="saveProperty($event)"
            />

            <modal-popup :isVisible="!!activeProperty">
              <div v-if="activeProperty" class="row modal-row-padding" v-click-outside="closeModal">
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Label</label>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeProperty.label"
                      placeholder="i.e. apartment"
                    />
                  </fieldset>
                </div>
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Bedrooms</label>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeProperty.beds"
                      placeholder="i.e. 2"
                    />
                  </fieldset>
                </div>
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Bathrooms</label>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeProperty.baths"
                      placeholder="i.e. 1"
                    />
                  </fieldset>                                                    
                </div>
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>PHPP/Tayseer Price</label>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      v-model="activeProperty.tayseerPrice"
                      placeholder=""
                    />
                  </fieldset>                                                    
                </div>
                <div class="col-3">
                  <fieldset class="form-group">
                    <label>Status</label>
                    <select class="form-control form-control-lg" v-model="activeProperty.status">
                      <option value="Available">Available</option>
                      <option value="Blocked">Blocked</option>
                      <option value="On Hold">On Hold</option>
                      <option value="Sold">Sold</option>
                      <option value="Unassigned">Unassigned</option>
                    </select>
                  </fieldset>                                                    
                </div>
                <div class="col-6">
                  <fieldset class="form-group">
                    <label>Viewpoint Images</label>
                    <input-asset v-model="activeProperty.images" :multiple="true"></input-asset>
                  </fieldset>
                </div>

                <div class="col-6">
                  <fieldset class="form-group">
                      <label>Associated Property Models</label>
                      <input-multi-select v-model="activeProperty.modelIds" :options="propertyModelOptions"></input-multi-select>
                    </fieldset>
                </div>

                <div class="col-12">
                  <button class="btn btn-sm btn-outline-danger" @click="activePropertyId = null">Cancel</button>
                  <button class="btn btn-sm btn-primary ml-1" @click="saveProperty(activeProperty)">Save</button>
                </div>
              </div>             
            </modal-popup>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import _ from 'lodash'
import InputAsset from '@/components/InputAsset'
import InputMultiSelect from '@/components/InputMultiSelect'
import ModalPopup from '@/components/ModalPopup'
import CkEditor from '@/components/CKEditor'
import VTable from '@/components/VTable'
import { mapGetters } from 'vuex'

export default {
  components: { CkEditor, InputAsset, InputMultiSelect, VTable },
  data () {
    return {
      activePropertyId: null,
      filterStatus: ['Available'],
      propertiesFilterText: '',
    }
  },

  computed: {
    ...mapGetters ([
      'propertyModels',
      'properties',
    ]),

    activeProperty () {
      return _.find(this.properties, property => {
        return property._id === this.activePropertyId
      })
    },

    filteredProperties () {
      return _.filter(this.properties, property => {
        if (this.filterStatus.length) {
          return property.label.toLowerCase().includes(this.propertiesFilterText.toLowerCase()) &&
            this.filterStatus.includes(property.status)
        } else {
          return property.label.toLowerCase().includes(this.propertiesFilterText.toLowerCase()) 
        }
      })
    },   

    propertyModelOptions () {
      return this.propertyModels.map(propertyModel => { 
        return { label: propertyModel.label, value: propertyModel._id }
      })
    }
  },

  methods: {
    addProperty () {
      const property = {
        _id: 'temp',
        label: '',
        displayName: '',
        marker: {
          x: 100,
          y: 100
        },
        price: '',
        status: '',
        images: [],
        modelIds: [],
        draft: false,
        msq: null,
        view: ''
      }
      this.$store.commit('ADD_PROPERTY', property)
      this.activePropertyId = property._id
    },
    
    closeModal () {
      this.activePropertyId = null
    },

    propertiesByIds (ids) {
      const properties =  _.filter(this.properties, property => {
        return ids.includes(property._id)
      })
      return properties
    },    

    propertyModelsByIds (ids) {
      const models =  _.filter(this.propertyModels, model => {
        return ids.includes(model._id)
      })
      return models
    },

    isAddingNewObject () {
      return Boolean(_.map(this.properties, property => { return property._id }).includes('temp'))
    },

    saveProperty (property) {
      this.$store.dispatch('SAVE_PROPERTY', property)
      this.activePropertyId = null
    },   
  },

  created () {
    this.$store.dispatch('FETCH_ASSETS')
    this.$store.dispatch('FETCH_PROPERTIES')
    this.$store.dispatch('FETCH_PROPERTY_MODELS')
  }
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";

  select {
    width: 100%;
  }

  .card {
    z-index: unset !important;
  }

  .living-option, .subsection, .property, .property-model {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;
    margin: 1em 0;
  }

  .selection-list {
    border-radius: 4px;
    padding: 7px;
    border: 1px solid #d4d4d4;   
    max-height: 200px;
    // overflow: scroll; 
  }

  .list-wrapper {
    max-height: 600px;
    // overflow: scroll;
  }

  .associated-model-list {
    color: #000;
  }

  .modal-row-padding {
    padding: 30px 0;
  }
</style>